import { render, staticRenderFns } from "./EditExhibitorExhibit.vue?vue&type=template&id=56543178&"
import script from "./EditExhibitorExhibit.vue?vue&type=script&lang=js&"
export * from "./EditExhibitorExhibit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports